import { Dispatch } from "react";
import { GETAPI, PATCHAPI } from "../../API/Api";
import {
  GET_ORGANIZATION_LIST_FAIL,
  GET_ORGANIZATION_LIST_REQUEST,
  GET_ORGANIZATION_LIST_SUCCESS,
  GET_SUPPORT_REQUEST_LIST_FAIL,
  GET_SUPPORT_REQUEST_LIST_REQUEST,
  GET_SUPPORT_REQUEST_LIST_SUCCESS,
  UPDATE_SUPPORT_REQUEST_STATUS_FAIL,
  UPDATE_SUPPORT_REQUEST_STATUS_REQUEST,
  UPDATE_SUPPORT_REQUEST_STATUS_SUCCESS,
  GET_NEWS_LETTER_LIST_FAIL,
  GET_NEWS_LETTER_LIST_SUCCESS,
  GET_NEWS_LETTER_LIST_REQUEST,
  GET_MEETING_SLOT_FAIL,
  GET_MEETING_SLOT_SUCCESS,
  GET_MEETING_SLOT_REQUEST,
  CREATE_MEETING_SLOT_FAIL,
  CREATE_MEETING_SLOT_REQUEST,
  CREATE_MEETING_SLOT_SUCCESS,
  GET_SALE_INQUIRY_FAIL,
  GET_SALE_INQUIRY_SUCCESS,
  GET_SALE_INQUIRY_REQUEST,
  UPDATE_DEMO_MEETING_STATUS_FAIL,
  UPDATE_DEMO_MEETING_STATUS_REQUEST,
  UPDATE_DEMO_MEETING_STATUS_SUCCESS,
  GET_USERS_LIST_FAIL,
  GET_USERS_LIST_SUCCESS,
  GET_USERS_LIST_REQUEST,
  GET_ORGANIZATION_DETAILS_FAIL,
  GET_ORGANIZATION_DETAILS_REQUEST,
  GET_ORGANIZATION_DETAILS_SUCCESS,
  GET_ORG_PAYMENT_DETAILS_FAIL,
  GET_ORG_PAYMENT_DETAILS_REQUEST,
  GET_ORG_PAYMENT_DETAILS_SUCCESS,
  ACTIVATE_EVAL_PROMO_FAIL,
  ACTIVATE_EVAL_PROMO_REQUEST,
  ACTIVATE_EVAL_PROMO_SUCCESS,
  DEACTIVATE_ORGANIZATION_FAIL,
  DEACTIVATE_ORGANIZATION_REQUEST,
  DEACTIVATE_ORGANIZATION_SUCCESS,
  DEACTIVATE_BREW_USER_FAIL,
  DEACTIVATE_BREW_USER_REQUEST,
  DEACTIVATE_BREW_USER_SUCCESS,
  GET_ORG_MEMBERS_LIST_FAIL,
  GET_ORG_MEMBERS_LIST_REQUEST,
  GET_ORG_MEMBERS_LIST_SUCCESS,
  ASSIGN_ACCOUNT_MANAGER_FAIL,
  ASSIGN_ACCOUNT_MANAGER_REQUEST,
  ASSIGN_ACCOUNT_MANAGER_SUCCESS,
  REMOVE_ACCOUNT_MANAGER_FAIL,
  REMOVE_ACCOUNT_MANAGER_REQUEST,
  REMOVE_ACCOUNT_MANAGER_SUCCESS,
  GET_ORG_PRICING_REQUEST,
  GET_ORG_PRICING_SUCCESS,
  GET_ORG_PRICING_FAIL,
  GET_ORG_PRICING_HISTORY_REQUEST,
  GET_ORG_PRICING_HISTORY_SUCCESS,
  GET_ORG_PRICING_HISTORY_FAIL,
  ORG_PRICING_MUTATION_REQUEST,
  ORG_PRICING_MUTATION_SUCCESS,
  ORG_PRICING_MUTATION_FAIL,
  ORG_PRICING_MUTATION_RESET,
  CREATE_ORGANIZATION_FAIL,
  CREATE_ORGANIZATION_REQUEST,
  CREATE_ORGANIZATION_SUCCESS,
} from "../../Constants/OrganizationConstant";
import { ApiConfig } from "../../Config/CommonConfig";
import { DELETEAPI, POSTAPI } from "../../API/Api";

export const OrganizationList =
  (payload: any) => async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: GET_ORGANIZATION_LIST_REQUEST });

      let data = await GETAPI(ApiConfig?.OrganizationList + payload);

      if (data && data.status === true) {
        dispatch({
          type: GET_ORGANIZATION_LIST_SUCCESS,
          data: data.data,
        });
      } else {
        dispatch({
          type: GET_ORGANIZATION_LIST_FAIL,
          data: [],
        });
      }
    } catch (error) {}
  };

export const UsersList = (payload: any) => async (dispatch: Dispatch<any>) => {
  try {
    dispatch({ type: GET_USERS_LIST_REQUEST });

    let data = await GETAPI(ApiConfig?.UsersList + payload);

    if (data && data.status === true) {
      dispatch({
        type: GET_USERS_LIST_SUCCESS,
        data: data.data,
      });
    } else {
      dispatch({
        type: GET_USERS_LIST_FAIL,
        data: [],
      });
    }
  } catch (error) {}
};

export const SupportRequestList =
  (payload: any) => async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: GET_SUPPORT_REQUEST_LIST_REQUEST });

      let data = await GETAPI(ApiConfig?.SupportList + payload);

      if (data && data.status === true) {
        dispatch({
          type: GET_SUPPORT_REQUEST_LIST_SUCCESS,
          data: data.data,
        });
      } else {
        dispatch({
          type: GET_SUPPORT_REQUEST_LIST_FAIL,
          data: [],
        });
      }
    } catch (error) {}
  };

export const UpdateSupportRequestStatus =
  (payload: any) => async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: UPDATE_SUPPORT_REQUEST_STATUS_REQUEST });

      // Construct URL with ID as parameter and send status in body
      const url = `${ApiConfig?.UpdateQueryStaus}/${payload?.id}/`;
      const data = await PATCHAPI(url, payload?.body);

      if (data && data.status === true) {
        dispatch({
          type: UPDATE_SUPPORT_REQUEST_STATUS_SUCCESS,
          data: data.data,
        });
      } else {
        dispatch({
          type: UPDATE_SUPPORT_REQUEST_STATUS_FAIL,
          data: [],
        });
      }
    } catch (error) {}
  };

export const NewsLettersAction =
  (payload: any) => async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: GET_NEWS_LETTER_LIST_REQUEST });

      let data = await GETAPI(ApiConfig?.NewsLetterList + payload);

      if (data && data.status === true) {
        dispatch({
          type: GET_NEWS_LETTER_LIST_SUCCESS,
          data: data.data,
        });
      } else {
        dispatch({
          type: GET_NEWS_LETTER_LIST_FAIL,
          data: [],
        });
      }
    } catch (error) {}
  };

export const MeetingSlotsAction =
  (payload: any) => async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: GET_MEETING_SLOT_REQUEST });

      let data = await GETAPI(ApiConfig?.MeetingSlotsList + payload);
      if (data && data.status === true) {
        dispatch({
          type: GET_MEETING_SLOT_SUCCESS,
          data: data.data,
        });
      } else {
        dispatch({
          type: GET_MEETING_SLOT_FAIL,
          data: [],
        });
      }
    } catch (error) {}
  };

export const CreateMeetingSlotAction =
  (payload: any) => async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: CREATE_MEETING_SLOT_REQUEST });

      let data = await POSTAPI(ApiConfig?.CreateMeetingSlot, payload, true);
      if (data && data.status === true) {
        dispatch({
          type: CREATE_MEETING_SLOT_SUCCESS,
          data: data.data,
        });
        return data;
      } else {
        dispatch({
          type: CREATE_MEETING_SLOT_FAIL,
          data: null,
        });
        return data;
      }
    } catch (error) {
      dispatch({
        type: CREATE_MEETING_SLOT_FAIL,
        data: null,
      });
      return null;
    }
  };

export const SaleInquiriesListAction =
  (payload: any) => async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: GET_SALE_INQUIRY_REQUEST });

      let data = await GETAPI(ApiConfig?.SaleInquiriesList + payload);
      if (data && data.status === true) {
        dispatch({
          type: GET_SALE_INQUIRY_SUCCESS,
          data: data.data,
        });
      } else {
        dispatch({
          type: GET_SALE_INQUIRY_FAIL,
          data: [],
        });
      }
    } catch (error) {}
  };

export const UpdateDemoMeetingStatus =
  (payload: any) => async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: UPDATE_DEMO_MEETING_STATUS_REQUEST });

      const url = `${ApiConfig?.UpdateDemoStatus}/${payload?.id}/`;
      const data = await PATCHAPI(url, payload?.body);
      if (data && data.status === true) {
        dispatch({
          type: UPDATE_DEMO_MEETING_STATUS_SUCCESS,
          data: data.data,
        });
      } else {
        dispatch({
          type: UPDATE_DEMO_MEETING_STATUS_FAIL,
          data: [],
        });
      }
    } catch (error) {}
  };

export const OrganizationDetailsAction =
  (orgId: number | string) => async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: GET_ORGANIZATION_DETAILS_REQUEST });
      const data = await GETAPI(`${ApiConfig?.OrganizationDetails}${orgId}/`);

      if (data && data.status === true) {
        dispatch({
          type: GET_ORGANIZATION_DETAILS_SUCCESS,
          data: data.data,
        });
      } else {
        dispatch({
          type: GET_ORGANIZATION_DETAILS_FAIL,
          data: [],
        });
      }
    } catch (error) {
      dispatch({ type: GET_ORGANIZATION_DETAILS_FAIL, data: [] });
    }
  };

export const OrganizationPaymentDetailsAction =
  (orgId: number | string) => async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: GET_ORG_PAYMENT_DETAILS_REQUEST });
      const data = await GETAPI(
        `${ApiConfig?.OrganizationPaymentDetails}${orgId}/`,
      );

      if (data && data.status === true) {
        dispatch({
          type: GET_ORG_PAYMENT_DETAILS_SUCCESS,
          data: data.data,
        });
      } else {
        dispatch({
          type: GET_ORG_PAYMENT_DETAILS_FAIL,
          data: [],
        });
      }
    } catch (error) {
      dispatch({ type: GET_ORG_PAYMENT_DETAILS_FAIL, data: [] });
    }
  };

export const ActivateOrgEvaluationAction =
  (payload: { promo_code: string; org_email: string; org_id: number }) =>
  async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: ACTIVATE_EVAL_PROMO_REQUEST });
      const data = await POSTAPI(
        ApiConfig?.ActivateEvaluationPromo,
        payload,
        true,
      );
      if (data && data.status === true) {
        dispatch({
          type: ACTIVATE_EVAL_PROMO_SUCCESS,
          data: data.data,
        });
      } else {
        dispatch({
          type: ACTIVATE_EVAL_PROMO_FAIL,
          data: [],
        });
      }
    } catch (error) {
      dispatch({ type: ACTIVATE_EVAL_PROMO_FAIL, data: [] });
    }
  };

export const DeactivateOrganizationAction =
  (payload: { orgId: number | string; deletion_reason: string }) =>
  async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: DEACTIVATE_ORGANIZATION_REQUEST });
      const data = await POSTAPI(
        `${ApiConfig?.DeactivateOrganization}${payload.orgId}/`,
        { deletion_reason: payload.deletion_reason },
        true,
      );

      if (data && data.status === true) {
        dispatch({
          type: DEACTIVATE_ORGANIZATION_SUCCESS,
          data: data.data,
        });
        return data;
      } else {
        dispatch({
          type: DEACTIVATE_ORGANIZATION_FAIL,
          data: data,
        });
        return data;
      }
    } catch (error: any) {
      dispatch({
        type: DEACTIVATE_ORGANIZATION_FAIL,
        data: null,
        error: error?.message,
      });
      return null;
    }
  };

export const DeactivateBrewUserAction =
  (payload: { userId: number | string; deletion_reason: string }) =>
  async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: DEACTIVATE_BREW_USER_REQUEST });
      const data = await POSTAPI(
        `${ApiConfig?.DeactivateBrewUser}${payload.userId}/`,
        { deletion_reason: payload.deletion_reason },
        true,
      );

      if (data && data.status === true) {
        dispatch({
          type: DEACTIVATE_BREW_USER_SUCCESS,
          data: data.data,
        });
        return data;
      } else {
        dispatch({
          type: DEACTIVATE_BREW_USER_FAIL,
          data: data,
        });
        return data;
      }
    } catch (error: any) {
      dispatch({
        type: DEACTIVATE_BREW_USER_FAIL,
        data: null,
        error: error?.message,
      });
      return null;
    }
  };

export const OrgMembersListAction =
  (orgId: number | string) => async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: GET_ORG_MEMBERS_LIST_REQUEST });
      const data = await GETAPI(
        `${ApiConfig?.OrgMembersAdminList}${orgId}/?page=1&page_size=100`,
        true,
      );

      if (data && data.status === true) {
        dispatch({
          type: GET_ORG_MEMBERS_LIST_SUCCESS,
          data: data.data,
        });
      } else {
        dispatch({
          type: GET_ORG_MEMBERS_LIST_FAIL,
          error: data?.message || "Failed to load members.",
        });
      }
    } catch (error: any) {
      dispatch({
        type: GET_ORG_MEMBERS_LIST_FAIL,
        error: error?.message || "Failed to load members.",
      });
    }
  };

export const AssignAccountManagerAction =
  (payload: { orgId: number | string; email: string }) =>
  async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: ASSIGN_ACCOUNT_MANAGER_REQUEST });
      const data = await POSTAPI(
        `${ApiConfig?.AccountManagerAdmin}${payload.orgId}/`,
        { email: payload.email },
        true,
      );

      if (data && data.status === true) {
        dispatch({
          type: ASSIGN_ACCOUNT_MANAGER_SUCCESS,
          data: data.data,
        });
        return data;
      } else {
        dispatch({
          type: ASSIGN_ACCOUNT_MANAGER_FAIL,
          data: data,
          error: data?.message || "Failed to assign account manager.",
        });
        return data;
      }
    } catch (error: any) {
      dispatch({
        type: ASSIGN_ACCOUNT_MANAGER_FAIL,
        data: null,
        error: error?.message,
      });
      return null;
    }
  };

export const RemoveAccountManagerAction =
  (payload: { orgId: number | string; orgMemberId: number | string }) =>
  async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: REMOVE_ACCOUNT_MANAGER_REQUEST });
      const data = await DELETEAPI(
        `${ApiConfig?.AccountManagerAdmin}${payload.orgId}/${payload.orgMemberId}/`,
        true,
      );

      if (data && data.status === true) {
        dispatch({
          type: REMOVE_ACCOUNT_MANAGER_SUCCESS,
          data: data.data,
        });
        return data;
      } else {
        dispatch({
          type: REMOVE_ACCOUNT_MANAGER_FAIL,
          data: data,
          error: data?.message || "Failed to remove account manager.",
        });
        return data;
      }
    } catch (error: any) {
      dispatch({
        type: REMOVE_ACCOUNT_MANAGER_FAIL,
        data: null,
        error: error?.message,
      });
      return null;
    }
  };

export interface CreateOrganizationPayload {
  org_name: string;
  org_type: string;
  owner_email: string;
  owner_fullname: string;
  account_manager_email?: string;
  confirm_same_domain?: boolean;
}

/**
 * Resolves with the API envelope. `status_code === 409` means a same-domain
 * organization exists and the caller must resend with `confirm_same_domain`.
 */
export const CreateOrganizationAction =
  (payload: CreateOrganizationPayload) => async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: CREATE_ORGANIZATION_REQUEST });
      const data = await POSTAPI(
        ApiConfig?.OrganizationAdminCreate,
        payload,
        true,
      );

      if (data && data.status === true) {
        dispatch({ type: CREATE_ORGANIZATION_SUCCESS, data: data.data });
        return data;
      }
      dispatch({
        type: CREATE_ORGANIZATION_FAIL,
        data: data,
        error: data?.message || "Failed to create organization.",
      });
      return data;
    } catch (error: any) {
      dispatch({
        type: CREATE_ORGANIZATION_FAIL,
        data: null,
        error: error?.message,
      });
      return null;
    }
  };

export const OrgPricingAction =
  (orgId: number | string) => async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: GET_ORG_PRICING_REQUEST });

      const data = await GETAPI(`${ApiConfig?.OrgPricingBase}${orgId}/`, true);

      if (data && data.status === true) {
        dispatch({
          type: GET_ORG_PRICING_SUCCESS,
          data: data.data,
        });
      } else {
        dispatch({
          type: GET_ORG_PRICING_FAIL,
          data: [],
          error: data?.message || "Failed to load organization pricing.",
        });
      }
    } catch (error: any) {
      dispatch({
        type: GET_ORG_PRICING_FAIL,
        data: [],
        error: error?.message || "Failed to load organization pricing.",
      });
    }
  };

export const OrgPricingHistoryAction =
  (orgId: number | string) => async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: GET_ORG_PRICING_HISTORY_REQUEST });

      const data = await GETAPI(
        `${ApiConfig?.OrgPricingBase}${orgId}/history/`,
        true,
      );

      if (data && data.status === true) {
        dispatch({
          type: GET_ORG_PRICING_HISTORY_SUCCESS,
          data: data.data,
        });
      } else {
        dispatch({
          type: GET_ORG_PRICING_HISTORY_FAIL,
          data: [],
          error: data?.message || "Failed to load pricing history.",
        });
      }
    } catch (error: any) {
      dispatch({
        type: GET_ORG_PRICING_HISTORY_FAIL,
        data: [],
        error: error?.message || "Failed to load pricing history.",
      });
    }
  };

export const CreateOrgPricingAction =
  (payload: {
    org_id: number;
    feature_id: number;
    action_event: string;
    credit_charge: number;
    content_type_id?: number | null;
    external_service_resource_id?: number | null;
    reason: string;
  }) =>
  async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: ORG_PRICING_MUTATION_REQUEST });

      const data = await POSTAPI(
        `${ApiConfig?.OrgPricingBase}create/`,
        payload,
        true,
      );

      if (data && data.status === true) {
        dispatch({
          type: ORG_PRICING_MUTATION_SUCCESS,
          data: data.data,
        });
      } else {
        dispatch({
          type: ORG_PRICING_MUTATION_FAIL,
          data,
          error: data?.message || "Failed to create pricing override.",
        });
      }

      return data;
    } catch (error: any) {
      dispatch({
        type: ORG_PRICING_MUTATION_FAIL,
        data: null,
        error: error?.message || "Failed to create pricing override.",
      });

      return null;
    }
  };

export const UpdateOrgPricingAction =
  (payload: { overrideId: number; credit_charge: number; reason: string }) =>
  async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: ORG_PRICING_MUTATION_REQUEST });

      const data = await PATCHAPI(
        `${ApiConfig?.OrgPricingBase}update/${payload.overrideId}/`,
        {
          credit_charge: payload.credit_charge,
          reason: payload.reason,
        },
        true,
      );

      if (data && data.status === true) {
        dispatch({
          type: ORG_PRICING_MUTATION_SUCCESS,
          data: data.data,
        });
      } else {
        dispatch({
          type: ORG_PRICING_MUTATION_FAIL,
          data,
          error: data?.message || "Failed to update pricing override.",
        });
      }

      return data;
    } catch (error: any) {
      dispatch({
        type: ORG_PRICING_MUTATION_FAIL,
        data: null,
        error: error?.message || "Failed to update pricing override.",
      });

      return null;
    }
  };

export const ClearOrgPricingAction =
  (payload: { overrideId: number; reason: string }) =>
  async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: ORG_PRICING_MUTATION_REQUEST });

      const data = await PATCHAPI(
        `${ApiConfig?.OrgPricingBase}${payload.overrideId}/reset/`,
        {
          reason: payload.reason,
        },
        true,
      );

      if (data && data.status === true) {
        dispatch({
          type: ORG_PRICING_MUTATION_SUCCESS,
          data: data.data,
        });
      } else {
        dispatch({
          type: ORG_PRICING_MUTATION_FAIL,
          data,
          error: data?.message || "Failed to clear pricing override.",
        });
      }

      return data;
    } catch (error: any) {
      dispatch({
        type: ORG_PRICING_MUTATION_FAIL,
        data: null,
        error: error?.message || "Failed to clear pricing override.",
      });

      return null;
    }
  };

export const ResetOrgPricingMutationAction =
  () => (dispatch: Dispatch<any>) => {
    dispatch({
      type: ORG_PRICING_MUTATION_RESET,
    });
  };
